import useFeature from '~/client/hooks/feature/useFeature';
import useSite from '~/client/hooks/useSite';

const useIsLoyaltyEnabled = () => {
  const { isBridgeSite } = useSite();
  const loyaltyActiveFlag = isBridgeSite ? 'isLoyaltyEnabled' : 'loyalty';
  const isLoyaltyEnabled = useFeature(loyaltyActiveFlag);
  return isLoyaltyEnabled;
};

export default useIsLoyaltyEnabled;
